import { useMediaQuery, useTheme } from '@mui/material';

export default function useQuery() {
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isDesktop = !isMobile;
    const isLargeDesktop = useMediaQuery(theme.breakpoints.up('lg'));
    const isExtraLargeDesktop = useMediaQuery(theme.breakpoints.up('xl'));

    return { isMobile, isDesktop, isLargeDesktop, isExtraLargeDesktop };
}
